/* tslint:disable */
import { Component, Vue } from 'vue-property-decorator'
import {
	faUpRightFromSquare,
	faEye,
	faEyeSlash,
	faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import RowEdit from '@/components/edit/RowEdit/index.vue'
import SelectPortal from '@/components/edit/SelectPortal/index.vue'
import ButtonGroups from '@/components/edit/ButtonGroups/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import LabelModified from '@/components/edit/LabelModified/index.vue'
import fetch from '@/helpers/fetch'

import tableHelper from '@/helpers/table'

import Control from '@/helpers/control'

import { library } from '@fortawesome/fontawesome-svg-core'
import { genId } from '@/helpers/gen-id'

import store from '@/store/store.js'

library.add(faUpRightFromSquare, faEye, faEyeSlash, faTrashAlt)

@Component({
	components: {
		Loader,
		RowEdit,
		SelectPortal,
		ButtonGroups,
		ManageArray,
		LabelModified,
	},
})
export default class TableDeadlineDetail extends Vue {
	dateFormatOptions = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}

	reviewerStatusOptions = getReviewerStatusOptions()
	sourceOptions = getSourceOptions()
	providencesOptions = getProvidencesOptions()
	costsStatusOptions = getCostsStatusOptions()
	statusOptions = getStatusOptions()
	difficultyOptions = getDifficultyOptions()
	ratingOptions = getRatingOptions()
	delayReasonOptions = getDelayReasonOptions()
	pedencyOptions = getpedencyOptions()

	highlighted: any = {}
	cnjLoading = false

	updateKey = 0

	loadingTrial = false
	$store: any
	control = new Control()

	providences = [] as Array<any>

	loadingSelectedTrial = true

	displayRating = false
	previousStatus = ''

	async mounted() {
		this.previousStatus = this.deadline.status
		// this.loadingSelectedTrial = true
		if (this.$store) {
			await Promise.all([
				this.$store.dispatch('fetchUsersList'),
				this.$store.dispatch('fetchAllTrials'),
				this.$store.dispatch('fetchCourthouses'),
				this.$store.dispatch('fetchCourts'),
				this.$store.dispatch('fetchSubjects'),
				this.$store.dispatch('fetchSystems'),
				this.loadProvidences(),
			])
		}

		if (this.deadline.trial) {
			setTimeout(() => {
				const found = this.trials.find(
					(trial) => trial.id === this.deadline.trial.id,
				)
				this.$store.dispatch('setSelectedTrial', found)
			}, 0)
		} else {
			this.$store.dispatch('setSelectedTrial', null)
		}

		if (!this.deadline.punctuality_team) {
			this.updatePunctualityTeam()
		}

		if (!this.deadline.punctuality_personal) {
			this.updatePunctualityPersonal()
		}

		this.loadingSelectedTrial = false
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			// const cnj = removeAccents(item.cnj.toLowerCase())
			const srt = this.assembleOption(item)

			return searchArray.every((string) => {
				return srt.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}

	assembleOption(option) {
		let item = ''
		if (option.secNumMain) {
			item += `${option.secNumMain.number} - ${option.secNumMain.type}`
		}
		item += `${option.secNumMain ? ' (' : ''}${this.formatCNJ(option.cnj)}${option.secNumMain ? ')' : ''}`

		return item
	}

	getOptionKey(option) {
		return option.idSec
	}

	set selectedTrial(value) {
		this.$store.dispatch('setSelectedTrial', value)
	}

	get selectedTrial() {
		return this.$store.state.deadlines.selectedTrial
	}

	get selectedDeadlineId() {
		return this.$store.state.deadlines.selectedDeadlineId
	}

	get deadlinesByid() {
		return this.$store.state.deadlines.deadlinesByid
	}

	get deadline() {
		return this.deadlinesByid[this.selectedDeadlineId]
	}

	get users() {
		return this.$store.state.user.usersList
	}

	get trials() {
		return this.$store.state.trials.trialsBySecondaryNumbers
	}

	get courthouses() {
		return this.$store.state.courts.courthousesList
	}

	get courts() {
		return this.$store.state.courts.courtsList
	}

	get subjects() {
		return this.$store.state.subjects.subjectsList
	}

	get subjectsByName() {
		return this.$store.state.subjects.subjectsByName
	}

	get systems() {
		return this.$store.state.systems.systemsList
	}

	get fields() {
		return this.$store.state.deadlines.fields
	}

	async onInput(field, value, reference?, password?) {
		const component: any = this.$refs[reference]?.[0]
		if (component && component?.setLoading) {
			component.setLoading(false)
		}

		this.updateKey++
		this.highlighted[field] = false

		const deadline: any = { id: this.selectedDeadlineId }

		if (
			field === 'duration' ||
			field === 'punctuality_team' ||
			field === 'punctuality_personal'
		) {
			value = parseInt(value, 10)
		}

		if (field === 'protocolDate') {
			this.updatePunctualityTeam()
		}

		if (field === 'deliveredDate') {
			this.updatePunctualityPersonal()
		}

		if (field === 'availableDate') {
			this.highlighted.awareDate = true
			deadline.awareDate = value
			Vue.set(this.deadline, 'awareDate', value)
		}

		let trialSubjects
		if (field === 'main_trial_cnj') {
			this.loadingTrial = true
			const trialId = value.id
			const trial = await this.getTrial(trialId)

			Vue.set(this.deadline, 'trial', trial)
			Vue.set(this.deadline.trial, 'groups', trial.group)
			this.$store.dispatch('setSelectedTrial', trial)

			value = value.cnj

			Vue.set(this.deadline, 'courthouse', trial.courthouse)
			deadline.courthouse_id = trial?.courthouse?.id
			this.highlighted.courthouse = true

			Vue.set(this.deadline, 'court', trial?.currentCourt)
			deadline.vara_court_id = trial?.currentCourt?.id
			this.highlighted.vara_court_id = true

			trialSubjects = trial.subjects
			if (trial.mainTrial) {
				trialSubjects = trial.mainTrial.subjects
			}

			if (trialSubjects && trialSubjects.length) {
				deadline.subjects = trialSubjects.filter((subject) => {
					return subject.subject.name !== '[EM BRANCO]'
				})

				Vue.set(this.deadline, 'subjects', deadline.subjects)
				this.highlighted.subjects = true
			}

			const procedure = trial.procedure
			if (procedure) {
				deadline.procedure = procedure
				Vue.set(this.deadline, 'procedure', procedure)
				this.highlighted.procedure = true
			}

			deadline.system_id = trial?.system?.id
			Vue.set(this.deadline, 'system', trial?.system || {})
			this.highlighted.system_id = true

			this.loadingTrial = false
		}

		let subjects
		if (trialSubjects || (trialSubjects && trialSubjects.length === 0)) {
			subjects = this.treat(trialSubjects)
		}

		if (field === 'subjects') {
			subjects = value
		}

		const saveArray: any[] = []
		if (subjects) {
			if (subjects.length || subjects.length === 0) {
				subjects.forEach((subject) => {
					let subjectObject = subject
					if (typeof subject === 'string') {
						subjectObject = this.subjectsByName[subject]
					}

					if (subjectObject) {
						const saveObject = {
							deadline_id: deadline.id,
							subject_id: subjectObject.id,
						}

						saveArray.push(saveObject)
					}
				})

				deadline.subjects = saveArray
			}
		}

		if (field === 'subjects') {
			value = saveArray
		}

		if (
			field === 'availableDate' ||
			field === 'awareDate' ||
			field === 'duration'
		) {
			const newFatalDate: Date | null = getFatalDate(
				this.deadline.awareDate,
				this.deadline.duration,
			)

			if (newFatalDate) {
				const dateOnly = newFatalDate.toISOString().split('T')[0]
				await Vue.nextTick()
				Vue.set(this.deadline, 'fatalDate', dateOnly)
				deadline.fatalDate = dateOnly
				this.highlighted.fatalDate = true
			}

			const newRealFatalDate: Date | null = getRealFatalDate(
				this.deadline.awareDate,
				this.deadline.duration,
			)

			if (newRealFatalDate) {
				const dateOnly = newRealFatalDate.toISOString().split('T')[0]
				await Vue.nextTick()
				Vue.set(this.deadline, 'realFatalDate', dateOnly)
				deadline.realFatalDate = dateOnly
				this.highlighted.realFatalDate = true
			}

			const newInternalDate = getInternalDate(deadline.fatalDate, 3)
			if (newInternalDate) {
				const dateOnly = newInternalDate.toISOString().split('T')[0]
				await Vue.nextTick()
				Vue.set(this.deadline, 'internalDate', dateOnly)
				deadline.internalDate = dateOnly
				this.highlighted.internalDate = true
			}
		}

		if (field === 'reviewerFirst_user_id') {
			if (typeof value !== 'string') {
				value = value.id
			}
		}

		deadline[field] = value

		if (password) {
			deadline.password = password
		}

		this.$emit('saving', true)

		const debouncedSave = this.control.debounce(this.save, 500)
		await debouncedSave(deadline)

		Vue.set(this.deadline, field, value)
	}

	password = ''
	getPassword = false
	addMovement = false
	onInputStatus(status) {
		this.addMovement = false
		this.getPassword = false

		if (status === 'Arquivado') {
			const emptyProvRating = this.providences.find(
				(prov) => prov.rating.value === '',
			)
			if (emptyProvRating) {
				this.deadline.status = this.previousStatus
				this.$bvToast.toast(
					'Não é possível arquivar se não houver classificação.',
					{
						title: 'Erro',
						noCloseButton: false,
						noAutoHide: true,
						toaster: 'b-toaster-top-center',
					},
				)
				return
			}
		}

		if (status === 'Arquivado' || status === 'Desinteresse') {
			this.getPassword = true
		} else if (status === 'Protocolado') {
			this.addMovement = true
		}

		if (!this.getPassword) {
			this.onInput('status', status)
			this.previousStatus = status
		}
	}

	onPasswordChange() {
		if (this.password && this.password.length === 8) {
			this.onInput('status', this.deadline.status, null, this.password)
		}
	}

	async save(deadline) {
		const response = await this.$store.dispatch('saveDeadline', deadline)
		this.$emit('saving', false)

		if (response.ok) {
			this.$emit('success', true)
		}
	}

	async getTrial(id) {
		const response = await fetch.get('/api/trials/' + id)
		return response.data
	}

	treat(array) {
		return array.map((subject) => {
			return subject.subject
		})
	}

	getMovementDate(deadline) {
		const date = deadline?.trial?.movements?.[0]?.date

		if (date) {
			return date.split('-').reverse().join('/')
		}

		return null
	}

	getMovementText(deadline) {
		if (deadline.trial.movements && deadline.trial.movements.length) {
			return deadline.trial.movements[0].text
		}
		return ''
	}

	getBussinessDifference = getBussinessDifference

	getGroup(deadline) {
		let group = deadline?.trial?.groups

		if (!group || !group.length) {
			group = deadline?.trial?.group
		}

		if (group && group.length) {
			return group?.[0]
		}

		return ''
	}

	getGroupName(deadline) {
		const group = this.getGroup(deadline)

		if (group && group?.group?.name) {
			return group?.group?.name
		}
	}

	getFirstClientName(deadline) {
		const group = this.getGroup(deadline)

		const clients = group?.group?.clients
		const clientName = clients?.[0]?.name
		return clientName
	}

	getClientReview(deadline) {
		return deadline?.trial?.groups?.[0]?.group?.client_review
			? 'Sim'
			: 'Não'
	}

	getCostsTo(deadline) {
		const courtCostsTo = deadline?.trial?.groups?.[0]?.group?.court_costs_to

		if (!courtCostsTo) {
			return []
		}

		return JSON.parse(courtCostsTo)
	}

	getGroupReponsible(deadline) {
		return deadline && deadline.trial && deadline.trial.groups
			? deadline.trial.groups[0]
			: null
	}

	getReponsible(group) {
		return group?.group?.reportSendingFrom?.email
	}

	dateDisabled(ymd, date) {
		// Disable weekends (Sunday = `0`, Saturday = `6`)
		const weekday = date.getDay()
		return weekday === 0 || weekday === 6
	}

	notifying = {
		responsible: false,
		responsibleCosts: false,
	}

	async notify(person) {
		this.notifying[person] = true
		const res = await fetch.post('/api/deadlines/notify', {
			deadline: { id: this.deadline.id },
			notify: person,
		})

		this.notifying[person] = false
	}

	movement = {
		text: '',
		date: null,
		visible: false,
	}

	savingMovement = false
	savingMovementSuccess = false
	savingMovementError = false
	async insertMovement() {
		this.savingMovementError = false
		if (this.movement.text === '' || this.movement.date === null) {
			this.savingMovementError = true
			return
		}

		this.savingMovement = true
		if (this?.deadline?.trial?.id) {
			const res = await fetch.post(
				'/api/trials/' + this?.deadline?.trial?.id + '/movements',
				this.movement,
			)

			this.savingMovement = false
			if (res.ok) {
				this.savingMovementSuccess = true
			}
		}
	}

	copiado = {}
	copyCNJ(value, id, secNum) {
		Vue.set(this.copiado, id, true)
		const secondaryNumber = this.selectedTrial?.secondaryNumbers?.find(
			(item) => item?.active && item?.number,
		)?.number
		if (secNum && secondaryNumber) {
			navigator.clipboard.writeText(secondaryNumber.toString())
		} else {
			navigator.clipboard.writeText(value)
		}
		setTimeout(() => {
			Vue.set(this.copiado, id, false)
		}, 2000)
	}

	formatCNJ(val) {
		if (val) {
			return tableHelper.formatCNJ(val)
		}

		return ''
	}

	copiarEmail = {}
	copyEmail(email, index) {
		navigator.clipboard.writeText(email)
		Vue.set(this.copiarEmail, index, true)

		setTimeout(() => {
			Vue.set(this.copiarEmail, index, false)
		}, 2000)
	}

	copiarTodos = false
	copyAllEmails() {
		let destinatarios =
			this.deadline?.trial?.groups?.[0]?.group?.court_costs_to

		// Verifica se 'court_costs_to' é uma string e tenta convertê-lo para um array
		if (typeof destinatarios === 'string') {
			try {
				// Se a string estiver no formato JSON, converte para array
				destinatarios = JSON.parse(destinatarios)
			} catch (error) {
				// Caso não seja JSON válido, divide a string pelos emails separados por vírgula
				destinatarios = destinatarios
					.split(',')
					.map((email) => email.trim())
			}
		} else {
			destinatarios = []
		}

		const advogado = this.getReponsible(this.deadline.trial.groups[0])
			? this.getReponsible(this.deadline.trial.groups[0])
			: ''

		// Junta os e-mails e o advogado em uma única string separada por vírgulas
		const todosEmails = [...destinatarios, advogado]
			.filter(Boolean)
			.join(', ')

		// Copia a lista de e-mails para o clipboard
		navigator.clipboard.writeText(todosEmails)

		this.copiarTodos = true

		setTimeout(() => {
			this.copiarTodos = false
		}, 2000)
	}

	async updatePunctualityPersonal() {
		if (this.deadline.deliveredDate && this.deadline.internalDate) {
			this.deadline.punctuality_personal = getBussinessDifference(
				this.deadline.deliveredDate,
				this.deadline.internalDate,
			)

			const deadline: any = {
				id: this.selectedDeadlineId,
				punctuality_personal: this.deadline.punctuality_personal,
			}
			await this.save(deadline)
		}
	}

	async updatePunctualityTeam() {
		if (this.deadline.protocolDate && this.deadline.internalDate) {
			this.deadline.punctuality_team = getBussinessDifference(
				this.deadline.protocolDate,
				this.deadline.internalDate,
			)

			const deadline: any = {
				id: this.selectedDeadlineId,
				punctuality_team: this.deadline.punctuality_team,
			}
			await this.save(deadline)
		}
	}

	async loadProvidences() {
		const res = await fetch.get(
			'/api/deadlines/' + this.deadline.id + '/providences',
		)

		if (res.ok && res.data.length > 0) {
			this.providences = res.data.map((prov) => {
				if (!prov.rating) prov.rating = { id: null, value: '' }
				prov.htmlId = genId()
				return prov
			})
		}
	}

	async upsertProvidence(prov) {
		this.$emit('saving', true)
		const res = await fetch.post(
			'/api/deadlines/' +
				this.deadline.id +
				'/providences/' +
				(prov.id || ''),
			{ value: prov.value },
		)

		this.$emit('saving', false)
		if (res.ok) {
			prov.id = res.data.id
			this.$emit('success', true)
		}
	}

	addProvidence() {
		this.providences.push({
			value: '',
			rating: { id: null, value: '' },
			htmlId: genId(),
		})
	}

	async removeProvidence(prov, index) {
		// quando a providencia esta apenas na UI
		if (!prov.id) {
			this.providences.splice(index, 1)
			return
		}

		const res = await fetch.delete(
			'/api/deadlines/' + this.deadline.id + '/providences/' + prov.id,
			{},
		)

		if (res.ok) {
			this.providences.splice(index, 1)
		} else {
			this.$bvToast.toast('Não foi possível remover providência', {
				title: 'Erro',
				noCloseButton: false,
				noAutoHide: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}

	get showRating() {
		return this.deadline.responsible?.id === store.user.id
	}

	get showRate() {
		return (
			this.deadline.reviewerFirst?.id === store.user.id ||
			this.deadline.reviewerFinal?.id === store.user.id
		)
	}

	async setRating(prov) {
		this.$emit('saving', true)
		const res = await fetch.post(
			'/api/deadlines/' +
				this.deadline.id +
				'/providences/' +
				prov.id +
				'/rating',
			{ value: prov.rating.value },
		)
		this.$emit('saving', false)

		if (res.ok) {
			this.$emit('success', true)
		}
	}
}

function getFatalDate(awareDateString, duration) {
	if (duration >= 0) {
		if (!awareDateString || !duration) return null

		const midDayUtcString = 'T12:00:00.000Z'
		let awareDate = new Date(awareDateString + midDayUtcString)

		let count = 0
		if (getWeekDayName(awareDate) === 'Sexta-feira') {
			count++
			awareDate = advanceToNextBusinessDay(awareDate)
		}

		const durationNumber = parseInt(duration, 10)

		let currDate = awareDate

		while (count < durationNumber) {
			currDate = advanceOneDay(currDate)
			count++
		}

		const weekDayName = getWeekDayName(currDate)
		if (weekDayName === 'Sábado' || weekDayName === 'Domingo') {
			currDate = advanceToNextBusinessDay(currDate)
		}

		return currDate
	}

	return null
}

function getRealFatalDate(awareDateString, duration) {
	if (duration >= 0) {
		if (!awareDateString || !duration) return null

		const midDayUtcString = 'T12:00:00.000Z'
		const awareDate = new Date(awareDateString + midDayUtcString)
		const durationNumber = parseInt(duration, 10)

		let currDate = awareDate
		let count = 0

		while (count !== durationNumber) {
			currDate = advanceToNextBusinessDay(currDate)
			count++
		}

		return currDate
	}

	return null
}

function advanceToNextBusinessDay(date) {
	let currDate = advanceOneDay(date)

	while (
		getWeekDayName(currDate) === 'Sábado' ||
		getWeekDayName(currDate) === 'Domingo'
	) {
		currDate = advanceOneDay(currDate)
	}

	return currDate
}

function advanceOneDay(date) {
	const hourInMs = 60 * 60 * 1000
	const dayInMs = 24 * hourInMs
	return new Date(date.getTime() + dayInMs)
}

function getWeekDayName(date) {
	const weekDayNames = [
		'Domingo',
		'Segunda-feira',
		'Terça-feira',
		'Quarta-feira',
		'Quinta-feira',
		'Sexta-feira',
		'Sábado',
	]
	const weekDayNumber = date.getDay()
	return weekDayNames[weekDayNumber]
}

function getReviewerStatusOptions() {
	return [
		{
			text: '',
			value: '',
		},
		{
			text: 'Pendente',
			value: 'pendente',
		},
		{
			text: 'Aprovado',
			value: 'aprovado',
		},
	]
}

function getSourceOptions() {
	return [
		{ value: '', text: '' },
		{ value: 'Diário Oficial', text: 'Diário Oficial' },
		{ value: 'Captura eletrônica', text: 'Captura eletrônica' },
		{ value: 'Demanda do Cliente', text: 'Demanda do Cliente' },
		{ value: 'Outro', text: 'Outro' },
	]
}

function getCostsStatusOptions() {
	return [
		{ name: '' },
		{ name: 'Gerar custas' },
		{ name: 'Verificar com o responsável' },
		{ name: 'Custas geradas' },

		{ name: 'Custas enviadas' },
		{ name: 'Pagamento interno' },

		{ name: 'Após a distribuição' },
		{ name: 'Não há' },
		{ name: 'Pagas' },
	]
}

function getStatusOptions() {
	return [
		{ name: '' },
		{ name: 'Elaboração', showInCalendar: true },
		{ name: 'Em 1ª Revisão', showInCalendar: true },
		{ name: 'Em 2ª Revisão', showInCalendar: true },
		{ name: 'Aguardando protocolo', showInCalendar: true },
		{ name: 'Protocolado', showInCalendar: true },
		{ name: 'Desinteresse', showInCalendar: true },
		{ name: 'Arquivado', showInCalendar: false, passwordProtected: true },
	]
}

function getDifficultyOptions() {
	return [
		{ name: '' },
		{ name: 'Difícil' },
		{ name: 'Médio' },
		{ name: 'Fácil' },
	]
}

function getRatingOptions() {
	return [
		{ name: '' },
		{ name: 'Ótimo' },
		{ name: 'Excelente' },
		{ name: 'Bom' },
		{ name: 'Regular' },
		{ name: 'Insatisfatório' },
		{ name: 'N/A' },
	]
}

function getpedencyOptions() {
	return [
		{ name: 'N/A', value: null },
		{ name: 'Não solicitado' },
		{ name: 'Solicitado' },
		{ name: 'Atendido' },
	]
}

function getDelayReasonOptions() {
	return [{ name: 'N/A' }, { name: 'Interno' }, { name: 'Externo' }]
}

function getProvidencesOptions() {
	return [
		{ name: 'Ag Int contra decisão denegatória em RE' },
		{ name: 'Ag Int contra decisão denegatória em REsp' },
		{ name: 'Agravo de Instrumento' },
		{ name: 'Agravo em Recurso Especial' },
		{ name: 'Agravo em Recurso Extraordinário' },
		{ name: 'Agravo Interno' },
		{ name: 'Agravo Regimental' },
		{ name: 'Alegações finais/Razões finais' },
		{ name: "Complementar ED's - Recurso de Agravo Interno" },
		{ name: 'Contestação' },
		{ name: 'Contraminuta de Ag Int contra decisão denegatória em RE' },
		{ name: 'Contraminuta de Ag Int contra decisão denegatória em REsp' },
		{ name: 'Contraminuta de Agravo de Instrumento' },
		{ name: 'Contraminuta de Agravo Interno' },
		{ name: 'Contrarrazões de Apelação' },
		{ name: 'Contrarrazões de Recurso Especial' },
		{ name: 'Contrarrazões de Recurso Extraordinário' },
		{ name: 'Desistência da execução judicial' },
		{ name: 'Digitalizar os autos' },
		{ name: 'EDPQ' },
		{ name: 'Embargos à Execução Fiscal' },
		{ name: 'Embargos de declaração' },
		{ name: 'Embargos de Divergência' },
		{ name: 'Emenda à Inicial' },
		{ name: 'Exceção de Pré-executividade' },
		{ name: 'Formular quesitos' },
		{ name: 'Habilitação de crédito' },
		{ name: 'Impugnação aos EDs' },
		{ name: 'Indicação de bens à penhora' },
		{ name: 'Indicar assistente técnico' },
		{ name: 'Iniciar cumprimento de sentença' },
		{ name: 'Manifestação sobre as informações prestadas' },
		{ name: 'Manifestação sobre conciliação' },
		{ name: 'Manifestação sobre prevenção/litispendência' },
		{ name: 'Manifestação' },
		{ name: 'Memoriais' },
		{ name: 'Pedido de efeito suspensivo' },
		{ name: 'Petição - produção de provas' },
		{ name: 'Petição art. 1.018 CPC' },
		{ name: 'Petição de desistência' },
		{ name: 'Ratificação de recurso' },
		{ name: 'Recolher custas' },
		{ name: 'Recolher honorários sucumbenciais' },
		{ name: 'Recolher/complementar preparo recursal' },
		{ name: 'Recurso de Apelação Adesivo' },
		{ name: 'Recurso de Apelação' },
		{ name: 'Recurso Especial Adesivo' },
		{ name: 'Recurso Especial' },
		{ name: 'Recurso Extraordinário Adesivo' },
		{ name: 'Recurso Extraordinário' },
		{ name: 'Recurso Ordinário' },
		{ name: 'Regularizar a representação processual' },
		{ name: 'Réplica' },
		{ name: 'Solicitar certidão de inteiro teor' },
	]
}

function getBussinessDifference(date1String, date2String) {
	if (!date1String || !date2String) return 'Inválido'

	const midDayUtcString = 'T12:00:00.000Z'
	const date1 = new Date(date1String + midDayUtcString)
	const date2 = new Date(date2String + midDayUtcString)

	let direction = 'positive'
	let endDate = date1
	let startDate = date2

	if (date1 <= date2) {
		direction = 'negative'
		startDate = date1
		endDate = date2
	}

	let count = 0

	let currDate = startDate

	while (currDate < endDate) {
		currDate = advanceToNextBusinessDay(currDate)
		count++
	}

	return direction === 'negative' ? -count : count
}

function getInternalDate(fatalDateString, duration) {
	const midDayUtcString = 'T12:00:00.000Z'
	let currDate = new Date(fatalDateString + midDayUtcString)
	let count = 0

	while (count < duration) {
		currDate = goBackOneDay(currDate)
		count++
	}

	let weekDayName = getWeekDayName(currDate)
	while (weekDayName === 'Sábado' || weekDayName === 'Domingo') {
		currDate = goBackOneDay(currDate)
		weekDayName = getWeekDayName(currDate)
	}

	return currDate
}

function goBackOneDay(date) {
	const hourInMs = 60 * 60 * 1000
	const dayInMs = 24 * hourInMs
	return new Date(date.getTime() - dayInMs)
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
